export const GET_ADMIN_ORGANIZATION_USERS_PATH = '/users'
export const POST_ADMIN_ORGANIZATION_USERS_PATH = '/users/bulk'
export const POST_SUPER_ADMIN_ORGANIZATION_USERS_PATH = id => `/organizations/${id}/users/bulk`

export const POST_ADMIN_ORGANIZATION_RESEND_INVITE_PATH = '/users/invitation-resend'
